import classNames from 'classnames';
import React from 'react';
import styles from './style.module.scss';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import LayoutSo from './LayoutSo';
import { BackArrowIcon } from 'assets';
import { useNavigate } from 'react-router-dom';
import { routeConstant } from 'shared/routes/RouteConstant';

export default function ViewSaleOrder() {
    const navigate = useNavigate();
    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, styles.cusContainer, 'text-start')}>
                <div className={classNames(styles.cusContainer)}>
                    <div className={classNames(styles.layoutPo)}>
                        <BackArrowIcon style={{ cursor: 'pointer' }} onClick={() => navigate(routeConstant.admin.so.list.path)} />
                        <div className={classNames(styles.headingPo)}>
                            <LayoutSo />
                        </div>
                    </div>
                </div>
            </div>
        </DashboardWrapper>
    );
}
